import * as React from "react"
import * as ProgressPrimitive from "@radix-ui/react-progress"
import { useTheme } from "@/contexts/ThemeContext"

import { cn } from "@/lib/utils"

const Progress = React.forwardRef(({ className, value, indicatorClassName, ...props }, ref) => {
  const { appTheme } = useTheme();
  
  // Force yellow for emerald and royal themes
  const themeIndicatorClass = (appTheme === 'emerald' || appTheme === 'royal') 
    ? 'bg-[#c9a227]' 
    : 'bg-primary';
  
  return (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn(
        "relative h-2 w-full overflow-hidden rounded-full bg-primary/20",
        className
      )}
      {...props}>
      <ProgressPrimitive.Indicator
        className={cn(
          "h-full w-full flex-1 transition-all",
          themeIndicatorClass,
          indicatorClassName
        )}
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }} />
    </ProgressPrimitive.Root>
  );
})
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }
